import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      nameRules: [
        v => Rules.isRequired(v),
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 90)
      ],
      abnRules: [
        v => Rules.isRequired(v),
        v => Rules.minLength(v, 2),
        v => Rules.maxLength(v, 30)
      ],
      addressRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 90)
      ],
      addressCityRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 90)
      ],
      addressPostCodeRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 10)
      ],
      contactEmailRules: [
        v => Rules.isEmail(v)
      ],
      contactPhoneRules: [
        v => Rules.isPhone(v)
      ],
      adminFeePercentageRules: [
        v => Rules.maxLength(v, 5)
      ]
    }
  }
}

